const areas = [
  '福岡市中央区', '福岡市博多区', '福岡市東区', '福岡市南区',
  '福岡市西区', '福岡市早良区', '福岡市城南区', '春日市',
  '大野城市', '太宰府市', '筑紫野市', '糸島市',
  '宗像市', '古賀市', '福津市', '飯塚市',
  '北九州市', '久留米市', '直方市', '行橋市',
];

export default function TenjinArea() {
  return (
    <section id="area" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-xs tracking-[0.3em] text-amber-600 font-medium uppercase mb-3 block">Service Area</span>
            <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-4">出張対応エリア</h2>
            <div className="w-16 h-0.5 bg-amber-400/50 mb-8"></div>
            <p className="text-sm text-gray-600 leading-relaxed mb-8">
              天神屋は<strong className="text-gray-800">福岡市・福岡県全域</strong>への出張買取に対応しています。
              「福岡 出張買取」「福岡市 貴金属買取」などでお探しの方はぜひご相談ください。
              遠方の場合もまずはお気軽にお問い合わせください。
            </p>
            <div className="flex flex-wrap gap-2 mb-8">
              {areas.map((area) => (
                <span
                  key={area}
                  className="bg-amber-50 text-amber-800 text-xs px-3 py-1.5 rounded-full font-medium border border-amber-100"
                >
                  {area}
                </span>
              ))}
            </div>
            <div className="bg-amber-50 rounded-xl p-5 flex items-start gap-4">
              <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-amber-700 text-sm"></i>
              </div>
              <p className="text-xs text-gray-600 leading-relaxed">
                上記エリア以外でも対応できる場合があります。まずはLINEまたはお電話でご相談ください。
                出張費は<strong className="text-gray-800">完全無料</strong>です。
              </p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden h-96 lg:h-[480px]">
            <iframe
              title="天神屋 出張買取エリア - 福岡市"
              src="https://www.google.com/maps?q=福岡県福岡市中央区港1丁目2&output=embed"
              className="w-full h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
